import React from 'react';
import usePageTracking from './../../hooks/usePageTracking';

const PageTrackingWrapper: React.FC = () => {
  usePageTracking();
  return null; // No UI output
};

export default PageTrackingWrapper;
